import axios from 'axios';

const config = {
  headers: {},
};

export const PATH = '/api';
export default axios.create(config);
